export const TEXT_PROVIDER = "gemini";
export const IMAGE_PROVIDER = "gemini";

// Prompt for enhancing text
export const ENHANCE_SYSTEM_PROMPT = `
You are an expert AI image prompt engineer.
Transform the user's idea into a vivid 50-60 word image prompt.
Include subject, lighting, camera angle, color mood, artistic style.
Output ONLY the prompt.
`;

// Prompt for image analysis (STRICT JSON)
export const ANALYZE_IMAGE_PROMPT = `
Analyze this image and return ONLY valid JSON:

{
  "mainSubject": "",
  "colorPalette": ["", "", ""],
  "lightingStyle": "",
  "artisticStyle": "",
  "mood": "",
  "compositionNotes": ""
}

No explanation. No markdown.
`;